<div [attr.data-test-id]="testIdName()" class="relative w-fit">
	<button (click)="toggle()" class="btn btn-primary btn-sm">
		{{ title() }}
		<svg-icon
			[src]="
				isOpen()
					? 'assets/icons/icon-chevron-up.svg'
					: 'assets/icons/icon-chevron-down.svg'
			"
		/>
	</button>

	@if (isOpen()) {
		<div
			(clickOutside)="close()"
			class="card card-no-padding absolute right-0 top-full mt-2 w-max min-w-48 max-w-56"
			data-test-id="content"
			vc-click-outside
		>
			<vp-link-list
				[linkListItems]="items()"
				[showDivider]="true"
				[showIcons]="false"
				(linkClicked)="close()"
			/>
		</div>
	}
</div>
